<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<style>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    box-shadow: inset 0px 4px 3px -5px #9e9e9e, inset 0px -4px 8px -5px #f5f5f5 !important
  }

  .data-tables{
    border-collapse: collapse;
  }
  .data-tables .fixed-right{
    background-color: white;
    position: sticky;
    right:0px;
    border-left:1px solid #e0e0e0;
    z-index: 1;
  }
  .data-tables .fixed-left{
    background-color: white;
    position: sticky;
    left:0px;
    border-right:1px solid #e0e0e0;
    cursor: default;
    z-index: 1;
  }
  .data-tables{
    .v-list-item {
      min-height: 38px;
    }
  }
</style>
<style lang="scss">
@import "./assets/css/app";
</style>
<style lang="sass" scope>
  $color: var(--primary-color)
  .area-select.large
    border: 1px solid #a8a8a8
    width: 100%
    line-height: 40px
    height: 52px
    color: rgba(0,0,0,.6)
    font-size: 18px
  .area-selected-trigger
    border-radius: 20px
  .cascader-menu-list-wrap
    border: 1px solid #e0e0e0
  .cascader-menu-list
    padding-left: 0px !important
  .cascader-menu-list .cascader-menu-option.selected
    color: $color
  .area-select-icon
    right: 40px
  .area-select.medium
    width: 30.33333%
    line-height: 40px
    height: 56px
    color: rgba(0,0,0,.6)
    font-size: 16px
    border: 1px solid #a1a1a1
    margin-left: 0px
  .area-selectable-list-wrap
    border: 1px solid #e0e0e0
  .area-selectable-list
    padding-left: 0px !important
  .area-selectable-list .area-selectable-option.selected
    color: $color
</style>